import { render, staticRenderFns } from "./LeonidaWorkList.vue?vue&type=template&id=2c43f4f9"
import script from "./LeonidaWorkList.vue?vue&type=script&lang=js"
export * from "./LeonidaWorkList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports